import { data, Icon as IconType } from "./IconDefinitions";

type Type = "solid" | "regular" | "light" | "thin" | "duotone" | "brands";

function mapToClass(type: Type): string {
  switch (type) {
    case "solid":
      return "fas";
    case "regular":
      return "far";
    case "light":
      return "fal";
    case "thin":
      return "fat";
    case "duotone":
      return "fad";
    case "brands":
      return "fab";
  }
}

export interface Props<TIcon extends IconType> {
  icon: TIcon["icon"];
  type: TIcon["type"];
  fixedWidth?: boolean;
  title?: string;
  className?: string;
  size?:
    | "lg"
    | "xs"
    | "sm"
    | "1x"
    | "2x"
    | "3x"
    | "4x"
    | "5x"
    | "6x"
    | "7x"
    | "8x"
    | "9x"
    | "10x";
}

export function Icon<TIcon extends IconType>(props: Props<TIcon>) {
  let className = mapToClass(props.type);
  if (props.fixedWidth) {
    className += " fa-fw";
  }
  if (props.size) {
    className += " fa-" + props.size;
  }
  if (props.className) {
    className += " " + props.className;
  }

  return (
    <i className={className} title={props.title} aria-hidden="true">
      {data[props.icon]}
    </i>
  );
}
